// extracted by mini-css-extract-plugin
export default {"bannerSection":"banner_bannerSection__iQmNw"};